export const COLLAPSIBLE_ARRAOW_ICON_SIZE = 10;
